/*
 * Default number of questions for a new file, by grade (1-8) and kind of file.
 *
 * Set 9 Oct 2026 (Beau): the count a student can work through in the time that kind of
 * file is meant to take, at that age -- the full table, the working-time targets and the
 * sources are in C:\Code\.briefs\question-count-defaults.md. The teacher can still move
 * the number up or down between `min` and `max`.
 *
 * - The same count for On level, Extra support and Challenge: the level changes how hard
 *   the questions are, not how many there are.
 * - A quiz or unit test is priced by question count (GET /pricing asset_bands). Every
 *   default here sits inside the first price band, so an untouched file never costs more
 *   than before; the page still caps `max` at the last band's ceiling.
 * - The ready-made files in the vault keep their own counts until the next catalogue
 *   build; these defaults are for files the generator makes.
 *
 * Plain script: in the browser it sets window.TTVQuestionCounts; in Node (tests) it is a
 * module.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.TTVQuestionCounts = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  // index 0 = Grade 1 ... index 7 = Grade 8
  var TABLE = {
    'worksheet':  { def: [5, 6, 6, 7, 8, 8, 10, 10],     min: 3, max: [8, 8, 10, 12, 12, 12, 15, 15] },
    'homework':   { def: [3, 3, 4, 4, 5, 5, 6, 6],       min: 2, max: [5, 5, 6, 8, 8, 8, 10, 10] },
    'exit-card':  { def: [2, 2, 3, 3, 3, 3, 3, 3],       min: 1, max: [3, 3, 3, 3, 3, 3, 3, 3] },
    'quiz':       { def: [5, 6, 6, 8, 8, 8, 10, 10],     min: 3, max: [10, 10, 12, 15, 15, 15, 20, 20] },
    'unit-test':  { def: [8, 8, 10, 10, 12, 12, 14, 15], min: 4, max: [12, 12, 15, 20, 20, 20, 20, 20] },
    'assignment': { def: [6, 6, 7, 8, 8, 9, 10, 10],     min: 4, max: [12, 12, 12, 12, 12, 12, 12, 12] }
  };

  function gradeIndex(grade) {
    var g = parseInt(grade, 10);
    if (isNaN(g)) return null;
    if (g < 1) g = 1;
    if (g > 8) g = 8;
    return g - 1;
  }

  // { def, min, max } for this kind of file at this grade, or null when the kind has no
  // question count (a lesson plan, a project) or the grade is not known yet.
  function spec(asset, grade) {
    var row = TABLE[asset];
    var i = gradeIndex(grade);
    if (!row || i == null) return null;
    return { def: row.def[i], min: row.min, max: row.max[i] };
  }

  function assets() { return Object.keys(TABLE); }

  // Why the price moves with the count -- shown next to the control for a file priced by
  // question count. `bands` is GET /pricing's asset_bands[asset].
  function costNote(bands) {
    if (!Array.isArray(bands) || bands.length < 2) return '';
    var parts = [];
    var from = 1;
    for (var i = 0; i < bands.length; i++) {
      var b = bands[i];
      var c = b.credits === 1 ? '1 credit' : b.credits + ' credits';
      parts.push((from === 1 ? 'Up to ' + b.max_items : from + ' to ' + b.max_items) + ' questions: ' + c);
      from = b.max_items + 1;
    }
    return 'Why more questions can cost more: each question is written for your grade, ' +
      'checked, and given a worked answer in the answer key, so a longer file takes more ' +
      'work to make. ' + parts.join('. ') + '.';
  }

  // The line for a file whose price does not change with the count.
  var FLAT_NOTE = 'The price is the same for any number of questions.';

  return { TABLE: TABLE, spec: spec, assets: assets, costNote: costNote, FLAT_NOTE: FLAT_NOTE };
});
